import { LocalizedDateWithDay } from '@mews-distributor/common';
import { UnicodeEntity } from '@mews/enums';
import { WallClockDate, WallClockDateService } from '@mews/framework/datetime';

interface DateRangeProps {
    startDate: WallClockDate;
    endDate: WallClockDate;
}

export const DateRange = ({ startDate, endDate }: DateRangeProps) => (
    <span>
        <LocalizedDateWithDay date={startDate} />
        {!WallClockDateService.isEqual(startDate, endDate) ? (
            <>
                {UnicodeEntity.NoBreakSpace}
                {UnicodeEntity.Dash}
                {UnicodeEntity.NoBreakSpace}
                <LocalizedDateWithDay date={endDate} />
            </>
        ) : null}
    </span>
);
